export default __webpack_public_path__ + "images/parent-signup/SplashLearn_Universe_Background-1e9a411d128310ff17588071e4887e4e.png";